import { BiometricEligibility, ConsumerEmailAndMobile } from '../../model'
import { getCredentialIds } from '@afterpay/utils/biometric'
import { isInAppBrowser, isInIframe } from '../../utils/device'
import { shouldAttemptAccountLink } from '../../utils/oAuth'

/** Helper functions that help non-hook usage */

export const isCredentialPresent = ({ email, mobile }: ConsumerEmailAndMobile): boolean => {
  const [storedCredentialIdsByEmail, storedCredentialIdsByMobile] = getCredentialIds(email, mobile)

  return storedCredentialIdsByEmail.length > 0 || storedCredentialIdsByMobile.length > 0
}

export const isBiometricCapableBrowser = (isIframeIntegration: boolean): boolean => !isIframeIntegration && !isInAppBrowser() && !isInIframe()

export const isEligibleBiometricLogin = ({
  oAuthState,
  isUserVerifyAuthenticatorAvailable,
  isBiometricCapableBrowser,
  isLoggedInWithOAuth,
  isPrivateBrowsingMode,
  isCashOnlyCohort,
}: BiometricEligibility): boolean => {
  // checkout is launched with oAuth or logged in with oauth
  const hasOAuthParams = shouldAttemptAccountLink(oAuthState)

  return (
    !hasOAuthParams && !isLoggedInWithOAuth && isUserVerifyAuthenticatorAvailable && isBiometricCapableBrowser && !isPrivateBrowsingMode && !isCashOnlyCohort
  )
}
